<template>
    <section class="animated-title" :class="{'is-active': isActive}" @click="onClick">
        <span class="animated-title__back" ref="back" v-if="goBack"> back </span>
        <div class="animated-title__wrapper" @mouseover="onOverElem" @mouseleave="onLeaveElem">
            <div class="animated-title__container">
                <div class="animated-title__inner">
                    <h2 class="animated-title__elem"> labor of fashion </h2>
                    <h2 class="animated-title__elem"> labor of fashion </h2>
                </div>
            </div>
            <div class="animated-title__container">
                <div class="animated-title__inner">
                    <h2 class="animated-title__elem"> labor of fashion </h2>
                    <h2 class="animated-title__elem"> labor of fashion </h2>
                </div>
            </div>
        </div>
        <div class="animated-title__punchlines" @mouseover="onOverElem" @mouseleave="onLeaveElem">
            <p class="animated-title__punchline" v-html="punchline"></p>
        </div>
    </section>
</template>

<script>
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import EventHub from '@/utils/EventHub'
import Cursor from '@/utils/Cursor'

export default {
  name: 'app-title-animated',

  components: {
      
  },

  props: {

  },

  computed: {
      punchline()
      {
          return this.punchlines[this.currentPunchline]
      }
  },
  data() {
    return {
        isActive: false,
        punchlines: ['study without desire spoils the memory,</br>and it retains nothing that it takes in.', 'the smallest feline is a masterpiece.'],
        currentPunchline: 0,
        goBack: true
    }
  },

  created()
  {
      
  },

  mounted()
  {
    
  },

  destroyed()
  {
      clearAllBodyScrollLocks()
  },

  methods: {
      onClick(ev)
      {
          if(ev.target.classList.contains('animated-title__elem') || ev.target.classList.contains('animated-title__inner') || ev.target.classList.contains('animated-title__punchline'))
          {
              this.updatePunchline()
          }
          else
          {
            this.close()
          }
      },

      onOverElem()
      {
          this.goBack = false
      },

      onLeaveElem()
      {
          this.goBack = true
      },

      updatePunchline()
      {
          if(this.currentPunchline + 1 < this.punchlines.length)
          {
            this.currentPunchline += 1
          }
          else
          {
            this.currentPunchline = 0
          }
      },

      setActive()
      {
          this.mouse = new Cursor()
          this.addEventListeners()
          this.isActive = true
          disableBodyScroll()
      },

      close()
      {
          this.mouse.destroy()
          this.removeEventListeners()
          this.isActive = false
          this.$parent.$el.style.zIndex = 4
          enableBodyScroll()
      },

        addEventListeners()
        {
            EventHub.$on('application:on-tick', this.onTick)
        },

        removeEventListeners()
        {
            EventHub.$off('application:on-tick', this.onTick)
        },

        onTick()
        {
            if(this.goBack && this.isActive)
            {
                this.$refs.back.style.transform = `translate3d(${this.mouse.x}px, ${this.mouse.y + 20}px, 0)`
            }
        }
  }
}
</script>

<style lang="stylus">
.animated-title
    cursor pointer
    z-index 99
    position fixed
    height 100vh
    width 100vw
    // padding-top 250px
    overflow hidden
    opacity 0
    visibility hidden
    background #0d0d16
    text-align center
    interpolate('padding-top', 1600px, 2560px, 300px, 460px);

    @media(max-width 1600px)
        interpolate('padding-top', 768px, 1600px, 180px, 300px);

    &.is-active
        opacity 1
        visibility visible

.animated-title__back
    position absolute
    top 0
    left 0
    text-transform uppercase
    // font-size 16px
    color $white
    line-height 2
    letter-spacing 0.1em
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 13px, 20px);

.animated-title__wrapper
    position absolute
    animation-name textSlide
    animation-duration 20s
    animation-timing-function linear
    animation-delay 0s
    animation-iteration-count infinite
    will-change transform

.animated-title__container
    display inline-block

    &:last-child
        position absolute
        top 0
        left 100%

.animated-title__inner
    display flex
    flex-direction row
    flex-wrap nowrap

.animated-title__elem
    user-select none
    cursor pointer
    width 100%
    margin-right 100px
    font-family 'Sabon'
    text-transform uppercase
    text-align center
    line-height 1
    letter-spacing 0.2em
    color $white
    white-space nowrap
    interpolate('font-size', 1600px, 2560px, 120px, 172px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 58px, 120px);

.animated-title__punchlines
    display inline-block
    margin-top 250px
    color $white
    text-transform uppercase
    letter-spacing 0.25em
    line-height 2.5
    text-align center
    interpolate('margin-top', 768px, 2560px, 120px, 450px);
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 13px, 20px);

@keyframes textSlide {
  from {
    transform translate3d(0, 53%, 0)
  }

  to {
      transform translate3d(-100%, 53%, 0)
  }
}
</style>